import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import {
  fetchCustomerProfile,
  fetchExpertProfile,
  subscribeToProfileUpdates,
} from "../store/profileSlice";
import { useAppDispatch } from "../store/hooks";

export const useProfilesStore = () => {
  const dispatch = useAppDispatch();
  const customerProfile = useSelector(
    (state: RootState) => state.profile.customerProfile
  );
  const user = useSelector((state: RootState) => state.profile.user);
  const userId = user?.id || "";
  const profileType = user?.role === "Expert" ? "Expert" : "Customer";
  const expertProfile = useSelector(
    (state: RootState) => state.profile.expertProfile
  );
  const status = useSelector((state: RootState) => state.profile.status);
  const error = useSelector((state: RootState) => state.profile.error);
  useEffect(() => {
    if (userId && profileType === "Customer") {
      dispatch(fetchCustomerProfile(userId));
    } else if (userId && profileType === "Expert") {
      dispatch(fetchExpertProfile(userId));
    }
  }, [dispatch, userId, profileType]);

  // useEffect(() => {
  //   let unsubscribe: any = null;

  //   if (userId) {
  //     const profileId =
  //       profileType === "Customer" ? customerProfile?.id : expertProfile?.id;

  //     if (profileId) {
  //       unsubscribe = dispatch(
  //         subscribeToProfileUpdates(profileId, profileType)
  //       );
  //     }
  //   }

  //   return () => {
  //     if (unsubscribe) unsubscribe();
  //   };
  // }, [dispatch, userId, profileType, customerProfile, expertProfile]);

  return {
    profile: profileType === "Customer" ? customerProfile : expertProfile,
    status,
    error,
  };
};
